module.exports = __webpack_public_path__ + "img/Flugridity.02bd357a.jpg";